/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React, { createContext, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import useThemePreference, { themes } from '../../../../Utilities/useThemePreference/useThemePreference.js';

var Context = /*#__PURE__*/createContext();
Context.displayName = 'ThemeContext';
var Provider = function Provider(_ref) {
  var children = _ref.children;
  var themeValue = useThemePreference();
  var theme = useMemo(function () {
    return {
      theme: themeValue,
      themes: themes,
      isDarkTheme: themeValue === themes.dark,
      isLightTheme: themeValue === themes.light
    };
  }, [themeValue]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: theme
  }, children);
};
Provider.propTypes = {
  children: PropTypes.node.isRequired
};
var useTheme = function useTheme() {
  return useContext(Context);
};
var Theme = {
  Context: Context,
  Provider: Provider,
  useTheme: useTheme
};

export { Theme as default };
